module.exports = __webpack_public_path__ + "static/img/1-05.24bb259.png";


//////////////////
// WEBPACK FOOTER
// ./static/feige/3/1-05.png
// module id = 206
// module chunks = 0